<script src="../../chat-help/src/main.js"></script>
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
  },
  created() {
    this.initWebSocket();
  },
  methods: {
    // 初始化 websocket
    initWebSocket() {
      let that = this;
      if ("WebSocket" in window) {
        // 创建websocket
        if(document.domain==='localhost'){
          // that.ws = new WebSocket("ws://"+document.domain+":8282");
          that.ws = new WebSocket("wss://api.nanshikeji.cn/wss");
        }else{
          that.ws = new WebSocket("wss://api.nanshikeji.cn/wss");
        }
        that.$globalWebSocket.setWs(that.ws);
        // that.ws.onopen = that.onopen();
        that.ws.onopen = function() {
          console.log('webSocket connect successful')
        };
        that.ws.onclose = function() {
          // 关闭 websocket
          console.log("webSocket connect closed");
          setTimeout(() => {
            that.initWebSocket();
          }, 2000);
        };
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
      }
    },
  }
}
</script>

<style>
  #app {
    background-color: #F8F8F8;
  }
  html{font-size:16px;}
  a,address,b,big,blockquote,body,center,cite,code,dd,del,div,dl,dt,em,fieldset,font,html,i,iframe,
  img,ins,label,legend,li,ol,p,pre,small,span,strong,u,ul,var {
    margin: 0;
    padding: 0;
    outline: none;
  }
  ul,li,ol{list-style:none;outline: none;}
  img,fieldset{border:0; }
  img{display:block; outline: none;}
  a{text-decoration:none; outline: none;}
  h1,h2,h3,h4,h5,h6{font-weight:100;}
  body{outline: none;}
  input,a{background:none; outline:none; border:none;}
  em,i,u {
    font-style: normal
  }
</style>
